var gApp = {
    call: function(method, url, data, callback) {
        var oReq = new XMLHttpRequest();
        oReq.open(method, url);
        oReq.onload = function(oEvent) {
            var json = false;
            if (oReq.responseText) {
                try {
                    json = JSON.parse(oReq.responseText);
                } catch (e) {
                    json = false;
                }
            }
            callback && callback(json, oReq);
        };
        oReq.send(data);
    },
    get: function(url, data, callback) {
        return gApp.call('GET', url, data, callback);
    },
    post: function(url, data, callback) {
        return gApp.call('POST', url, data, callback);
    },
    put: function(url, data, callback) {
        return gApp.call('PUT', url, data, callback);
    },
    delete: function(url, data, callback) {
        return gApp.call('DELETE', url, data, callback);
    }
};
